export enum DamageIssueType {
    APPARENT_OUTSIDE_PACKAGING = 'Apparent (outside packaging)',
    CONCEALED_INTERNAL_PACKAGING = 'Concealed (internal packaging / unit of sale)'
}
